import React, {useEffect, useState} from "react";
import {inject, observer} from "mobx-react";
import logo from "../img/official_logo.svg";
import {useRouteError, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import { captureMessage } from "../lib/utils";
import { BETA, DEV } from "../lib/configMgr";

const ErrorPage = ({error = null, stackTrace = null, userStore}) => {
  const routerError = useRouteError();
  const {isAdmin} = userStore;
  const navigate = useNavigate();


  if (error === null) {
    error = routerError;
    stackTrace = error?.stack;
  }

  toast.error("We encountered an error, we're looking into it");
  captureMessage(error, "error", {stackTrace});
  useEffect(() => {
    if (!DEV && !BETA) {
      navigate("/", { replace: true });
    }
  }, []);

  const handleBackToMain = (e) => {
    e.preventDefault();
    navigate("/", { replace: true });
  };

  return (
    <div className="app-container error-page">
      <div className="logo-wrapper">
        <img src={logo} className="app-logo" alt="Plex Research" />
      </div>
      <div className="error-content">
      <span>
        We seem to have encountered a problem. Please go back to the <a href="/" onClick={handleBackToMain}>main page</a> and try again.
      </span>
        <br />
        {isAdmin && (
          <details>
            <div className="error-header">{error && error.toString()}</div>
            <div className="error-details">{
              stackTrace?.split("\n").map((line, idx) => (<span key={idx}>{line}<br className='newline' /></span>))
            }</div>
          </details>
        )}
      </div>
      <div>
        <a href="/" onClick={handleBackToMain}>Back to the main page</a>
      </div>
    </div>
  );
}

export default inject("userStore")(observer(ErrorPage));
